var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:[_vm.$style.animation, {
      'is-visible': _vm.playAnimation,
    }]},[_c('Animation',{class:_vm.$style.animationItem,attrs:{"path":_vm.animation,"play":_vm.playAnimation,"options":{ autoplay: false }}})],1),_c('div',{class:[_vm.$style.content, {
      'is-visible': _vm.playAnimation,
    }]},[_c('div',{class:_vm.$style.title},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_c('div',{class:_vm.$style.description},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }